import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

export function login(data) {
  return request({
    url: "/User/login",
    method: "post",
    data,
  });
}

export function getInfo(data) {
  return request({
    url: "/User/getinfo",
    method: "post",
    data,
  });
}

export function yzm(data) {
  return request({
    url: "/user/code",
    method: "post",
    data,
  });
}
export function juanbaoGames(data) {
  return plaintextrequest({
    url: "/game/juanbaoGames",
    method: "post",
    data,
  });
}

export function usersJuanbaoGames(data) {
  return plaintextrequest({
    url: "/game/usersJuanbaoGames",
    method: "post",
    data,
  });
}

export function mygame(data) {
  return plaintextrequest({
    url: "/game/mygame",
    method: "post",
    data,
  });
}

export function mygift(data) {
  return plaintextrequest({
    url: "/user/myGiftlists",
    method: "post",
    data,
  });
}

export function news(data) {
  return plaintextrequest({
    url: "/Information/news",
    method: "post",
    data,
  });
}
export function activity(data) {
  return plaintextrequest({
    url: "/Information/activitys",
    method: "post",
    data,
  });
}

export function newsdetail(data) {
  return plaintextrequest({
    url: "/Information/newsdetail",
    method: "post",
    data,
  });
}

// 我的抵扣券
export function mycoupons(data) {
  return plaintextrequest({
    url: "/Coupon/mycouponslists",
    method: "post",
    data,
  });
}

export function ptbRecord(data) {
  return request({
    url: "/pay/ptbRecord",
    method: "post",
    data,
  });
}

export function gameRecord(data) {
  return request({
    url: "/pay/gameRecord",
    method: "post",
    data,
  });
}

export function register(data) {
  return request({
    url: "/user/register",
    method: "post",
    data,
  });
}

export function gamelist(data) {
  return plaintextrequest({
    url: "/GoldCoin/gamelist",
    method: "post",
    data,
  });
}

// 修改密码
export function forgetPassword(data) {
  return request({
    url: "/user/forgetPassword",
    method: "post",
    data,
  });
}

// 月卡
export function McStatus(data) {
  return request({
    url: "/Monthcard/McStatus",
    method: "post",
    data,
  });
}

// 注销账户
export function accountCancel(data) {
  return request({
    url: "/user/logoutuser",
    method: "post",
    data,
  });
}

// 密码注销账户
export function passCancel(data) {
  // console.log('密码注销账户传输的数据----------------',data);
  return request({
    url: "/user/logoutuserpass",
    method: "post",
    data,
  });
}

export function getBoxSetting(data) {
  return request({
    url: "user/boxSetting",
    method: "post",
    data,
  });
}

// 获取用户信息
export function getUserInfo(data) {
  return request({
    url: "/PublicH5/getuinfo",
    method: "post",
    data,
  });
}


// 获取客服 url
export function getKefuInfo(data) {
  return request({
    url: "/PublicH5/getkfuinfo",
    method: "post",
    data,
  });
}